module.exports = __webpack_public_path__ + "static/chiaus-62ba2d095784d403dd27992fa8ff3a74.svg";